import createReducer from "./../createReducer";
import { handlersMarkers } from "./handlers";

export default createReducer({}, handlersMarkers);
